export default "__VITE_ASSET__717e93c2__"